import { DiscountRepository } from "core/repository";
import DiscountFormCreatePresenter from "./create.presenter";

import { DiscountConstraint } from "core/constraint";
import validate from "util/validate";

class DiscountFormEditPresenter extends DiscountFormCreatePresenter {
  initialState() {
    return {
      ...super.initialState(),
      creating: false,
      title: "Editar Desconto"
    };
  }

  async onStart() {
    await super.onStart();
  }

  async getDiscount() {
    const discountUuid = this.routeParams.discountUuid;
    return await DiscountRepository.getOnline(discountUuid);
  }

  async callRepository(params) {
    const discountUuid = this.routeParams.discountUuid;
    delete params.created_at;
    return await DiscountRepository.updateDiscount(discountUuid, params);
  }

  validateForm(params) {
    const errors = {};

    const validation = validate(params, DiscountConstraint.edit, {
      fullMessages: false
    });
    if (!!validation) {
      Object.entries(validation)
        .map(([field, errors]) => ({ field, content: errors.join(", ") }))
        .forEach(({ field, content }) => (errors[field] = content));
    }

    return errors;
  }
}

export default DiscountFormEditPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/discount/form/edit.presenter.js